// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__MhAts","upload":"Small_upload__1CiJn","imageWrap":"Small_imageWrap__2WJ0c","removeBtn":"Small_removeBtn__3wZzV"};